import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { HttpLoaderService, KeyValuePair, ValidationMessage } from '@tymes4-shared';
import {SaleCategory, SaleCategoryService} from '../../api';

@Component({
    selector: 'app-edit-sale-category-form',
    templateUrl: './edit-sale-category-form.component.html',
    standalone: false
})
export class EditSaleCategoryFormComponent implements OnInit {
  public isNew: boolean;
  public isReadOnly: boolean;
  public form: FormGroup;
  validationMessages: KeyValuePair<ValidationMessage[]> = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: { saleCategory: SaleCategory; isNew: boolean, title: string },
    public dialogRef: MatDialogRef<EditSaleCategoryFormComponent>,
    private saleCategoryService: SaleCategoryService,
    private loader: HttpLoaderService
  ) {}

  ngOnInit() {
    this.isNew = this.passedData.isNew;
    this.validationMessages = {
      Name: [{ type: 'noSpaces', message: 'SALE-CATEGORIES.FORM.VALIDATION.NAME-NO-SPACES' }],
      Code: [{ type: 'noSpaces', message: 'SALE-CATEGORIES.FORM.VALIDATION.CODE-NO-SPACES' }]
    };

    this.form = new FormGroup({
      Id: new FormControl(0),
      Name: new FormControl('', [Validators.required, Validators.maxLength(100), this.noSpacesValidator]),
      Code: new FormControl('', [Validators.required, Validators.maxLength(50), this.noSpacesValidator]),
      TranslationCode: new FormControl('', [Validators.required, Validators.maxLength(100)]),
      TabOrder: new FormControl(0, [Validators.required, Validators.min(0)]),
      Active: new FormControl(true),
      IsAlwaysVisibleInShop: new FormControl(false)
    });

    if (!this.isNew && this.passedData.saleCategory) {
      this.form.patchValue(this.passedData.saleCategory);
      this.form.get('Code')?.disable();

      const nonTicketProductType = 2;
      this.isReadOnly = this.passedData.saleCategory.SaleCategoryType === nonTicketProductType;

      if (this.isReadOnly) {
        this.form.disable();
      }
    }
  }

  noSpacesValidator(control: AbstractControl): ValidationErrors | null {
    if (control.value && control.value.includes(' ')) {
      return { noSpaces: true };
    }
    return null;
  }

  submit() {
    const formValue = this.form.getRawValue();
    this.loader.open();

    const observable = this.isNew
      ? this.saleCategoryService.createSaleCategory(formValue)
      : this.saleCategoryService.updateSaleCategory(formValue);

    observable.subscribe({
      next: () => {
        this.dialogRef.close(true);
        this.loader.close();
      },
      error: () => {
        this.loader.close();
      }
    });
  }
}
